<p-toolbar styleClass="custom-header">
  <ng-template pTemplate="start">
    <div class="header-start">
      <nav class="breadcrumbs" aria-label="Breadcrumb">
        @for (breadcrumb of breadcrumbs(); track breadcrumb.label; let isLast = $last) {
          @if (breadcrumb.label) {
            @if (breadcrumb.url && !isLast) {
              <a [routerLink]="breadcrumb.url" class="breadcrumb-link">
                {{ breadcrumb.label }}
              </a>
              <ng-icon name="heroChevronRight" size="16" class="breadcrumb-separator"></ng-icon>
            } @else {
              <span class="breadcrumb-current">{{ breadcrumb.label }}</span>
            }
          }
        }
      </nav>
    </div>
  </ng-template>

  <ng-template pTemplate="end">
    <div class="header-end">
      @if (isAuthenticated()) {
        <app-user-avatar [fullName]="userName() || ''" [avatarImage]="avatarUrl() || ''" [size]="'normal'" />
      }
      <app-button (click)="logout()" fillMode="flat" rounded="full" width="40px" height="40px">
        <ng-icon name="heroArrowRightOnRectangle" size="20" class="logout-icon"></ng-icon>
        <!-- <span>Logout</span> -->
      </app-button>
    </div>
  </ng-template>
</p-toolbar>
